import { Region } from '../../interfaces/GameInterface';
import './SearchBar.css';

interface Props {
  value: string;
  onSearch: (term: string) => void;
  region: Region | 'all';
  onRegionChange: (region: Region | 'all') => void;
  regionCounts: { na: number; eu: number; jp: number };
}

const REGIONS: { key: Region | 'all'; label: string }[] = [
  { key: 'all', label: 'All regions' },
  { key: 'na', label: 'NA' },
  { key: 'eu', label: 'EU' },
  { key: 'jp', label: 'JP' },
];

function SearchBar({
  value,
  onSearch,
  region,
  onRegionChange,
  regionCounts,
}: Props) {
  return (
    <div className="searchbar">
      <div className="search-input">
        <svg viewBox="0 0 24 24" className="search-icon" aria-hidden="true">
          <path
            fill="currentColor"
            d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14"
          />
        </svg>
        <input
          type="search"
          placeholder="Search 3,700+ games by title, developer or publisher…"
          value={value}
          onChange={(e) => onSearch(e.target.value)}
          aria-label="Search games"
        />
        {value && (
          <button
            className="clear"
            onClick={() => onSearch('')}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
      <div className="region-filters" role="group" aria-label="Filter by region">
        {REGIONS.map((r) => {
          const count =
            r.key === 'all' ? undefined : regionCounts[r.key as Region];
          return (
            <button
              key={r.key}
              className={`chip ${region === r.key ? 'active' : ''}`}
              onClick={() => onRegionChange(r.key)}
            >
              {r.label}
              {count !== undefined && <span className="chip-count">{count}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SearchBar;
